export enum PermissionLevel {
  SUPER_ADMIN,
  PARTNER,
  ADMIN,
  MANAGER,
  EMPLOYEE
}
